import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import PaperImage from "src/modules/3rd-party-management/assets/images/paper.svg";
import { Table } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';
import {
    hasNonEmptyArray,
    parseHandelsregisterOrganizationData
} from "../../helpers";

const Publications = ({
    t,
    activeAccordion,
    setActiveAccordion,
    detailsQuery
}) => {
    const dateUtils = new DateUtils();
    const data = parseHandelsregisterOrganizationData(detailsQuery?.data?.company);
    // publications feature returns under "history"
    const history = data?.history || [];

    if (!hasNonEmptyArray(history)) {
        return null;
    }

    const label = (value) => {
        if (!value) {
            return '-';
        }
        if (typeof value === 'string') {
            return value;
        }
        return value.en || value.de || '-';
    };

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('publications')}
            className={activeAccordion === 'publications' ? 'active' : ''}
            eventKey={'publications'}
        >
            <Accordion.Header>
                <img src={PaperImage} alt="" />
                <span>{t('Publications & Register History')}</span>
            </Accordion.Header>

            <Accordion.Body>
                <div className="table-responsive">
                    <Table bordered hover striped size="sm" className="mb-0">
                        <thead>
                            <tr>
                                <th>{t('Date')}</th>
                                <th>{t('Event')}</th>
                                <th>{t('Description')}</th>
                                <th>{t('Details')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {history.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        {item.start_date
                                            ? dateUtils.convertDateToDate(item.start_date, INTERNATIONAL_DATE_FORMAT)
                                            : '-'}
                                    </td>
                                    <td>{label(item.name)}</td>
                                    <td>{label(item.description?.short) || label(item.description)}</td>
                                    <td>
                                        {typeof item.details?.value === 'string'
                                            ? item.details.value
                                            : (item.details?.linked_entities?.organization?.name || '-')}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default withNamespaces()(Publications);
